import { httpClient } from '../httpClient';
import { apiErrorHandler } from './helpers';

export const postProduct = productInfo => {
  return httpClient
    .post('/admin/product', productInfo)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error.response;
    });
};

export const getAllProduct = () => {
  return httpClient
    .get('/admin/product')
    .then(response => response)
    .catch(error => error.response);
};

export const updateProduct = (id, productInfo) => {
  return httpClient
    .patch(`/admin/product/${id}`, productInfo)
    .then(response => response)
    .catch(error => error.response);
};

export const deleteProduct = id => {
  return httpClient
    .delete(`/admin/product/${id}`)
    .then(response => response)
    .catch(error => error.response);
};
